import { provideBrightaiPlugin } from './brightai.plugin';

export const BrightaiModule = [
  provideBrightaiPlugin(),
];
